// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b6154bcb","513":"f5bb6c0f","787":"99e241cc"}[chunkId] + ".chunk.js";
};